import { render } from "./ClimateSmartPPPTab.vue?vue&type=template&id=17be843c&scoped=true"
import script from "./ClimateSmartPPPTab.vue?vue&type=script&lang=js"
export * from "./ClimateSmartPPPTab.vue?vue&type=script&lang=js"

import "./ClimateSmartPPPTab.vue?vue&type=style&index=0&id=17be843c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17be843c"]])

export default __exports__